export default __webpack_public_path__ + "skin/sounds/new-chat-message.mp3";